import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import ProfileDetails from './ProfileDetails';

const marcas = ['anhanguera', 'unime', 'uniasselvi',
  'unirondon', 'unopar', 'fama', 'unic',
  'uniderp', 'pitagoras', 'lfg', 'uk'];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const MenuEditView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { editMenu } = useSelector((state) => state.menu);

  useEffect(() => {
    if (
      editMenu.status === CONSTANTS.STATUS.DONE
      && editMenu.type === 'MENU::UPDATE_MENU'
    ) {
      dispatch(actions.menu.editMenu.redirect());
      navigate('/app/menu');
    }
  }, [editMenu]);

  useEffect(() => {
    if (id !== editMenu.menu._id) dispatch(actions.menu.editMenu.get(id));
  }, [id]);

  return (
    <Page className={classes.root} title="MenusEditView">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xs={12}>
            {editMenu.status === CONSTANTS.STATUS.DONE && editMenu.type !== 'MENU::UPDATE_MENU_REDIRECT' ? (
              <ProfileDetails menu={editMenu.menu} marcas={marcas} />
            ) : (
              <LinearProgress />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default MenuEditView;
